export const trimWhiteSpace = (word) => {
  let trimedWord = word.toLowerCase().replace(/_/g, "");
  return trimedWord;
};
